import { userDetail } from "./ActionTypes"

    export const loginDetailSave = (data)=>{
        return{
            type:userDetail.SAVE_lOGIN_DETAILS,
            payload:data
        }
    }